export const getAnalyticsTableColumnData = (type: SkillsMatrixTable) => {
  switch (type) {
    case SkillsMatrixTable.TOP_SKILLS:
      return [
        { field: 'skill', headerName: 'Skill', minWidth: 120, flex: 1.5 },
        { field: 'count', headerName: 'Count', minWidth: 100, flex: 1 },
      ];
    case SkillsMatrixTable.TOP_JOB_TITLES:
      return [
        { field: 'jobTitle', headerName: 'Job Title', minWidth: 120, flex: 1.5 },
        { field: 'count', headerName: 'Count', minWidth: 100, flex: 1 },
      ];
    default:
      return [
        { field: 'field', headerName: 'Field Name', minWidth: 120, flex: 1.5 },
        { field: 'count', headerName: 'Count', minWidth: 100, flex: 1 },
      ];
  }
};

export const enum SkillsMatrixTable {
  TOP_SKILLS = 'top-skills',
  TOP_JOB_TITLES = 'top-job-titles',
}
